import resume from '../data/benjamin_gregory_resume_20251029-redacted.pdf'; // client/src/data/BenjaminGregoryResume20250819-1.pdf

export const getResumeUrl = (): string => {
  return resume;
};

export const getResumeFromGitHub = async (): Promise<string> => {
  throw new Error('This function is not implemented yet.'); 

};

export const downloadResume = (): void => {
  const link = document.createElement('a');
  link.href = resume;
  link.download = 'Benjamin_Gregory_Resume.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const openResumeInNewTab = (): void => {
  window.open(resume, '_blank', 'noopener,noreferrer');
};